import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HomeRoutingModule } from './home-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { IndexComponent } from './Index/Index.component';
import { ChartsModule } from 'ng2-charts';
import { PendingEmailVerificationComponent } from './pending-email-verification/pending-email-verification.component';
import { SettingComponent } from './setting/setting.component';
import { PageVisitedHistoryComponent } from './page-visited-history/page-visited-history.component';
import { LoginHistoryComponent } from './login-history/login-history.component';
import { ProfileComponent } from './profile/profile.component';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu/menu.component';
import { RoleComponent } from './role/role.component';
import { HomeComponent } from './home.component';
import { SidebarMenuComponent } from './sidebar-menu/sidebar-menu.component';
import { HttpInterceptorService } from '../_services/http-interceptor.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbdSortableHeader } from './informes/irm/sortable.directive';
import { InformesIRMComponent } from './informes/irm/informes-irm.component';
import { InformesDLPComponent } from './informes/dlp/informes-dlp.component';
import { ClasificacionDeDatosComponent } from './administracion/clasificacion-de-datos/clasificacion-de-datos.component';
import { EtiquetasDeClasificacionComponent } from './administracion/etiquetas-de-clasificacion/etiquetas.component';
import { EtiquetasDeConfidencialidadComponent } from './administracion/etiquetas-de-confidencialidad/etiquetas-confidencialidad.component';
import { PanelDeCumplimientoComponent } from './administracion/panel-de-cumplimiento/panel-cumplimiento.component';
import { ProcedimientosComponent } from './manual/procedimientos/procedimientos.component';
import { ManualDeUsuarioComponent } from './manual/usuario/usuario.component';
import { DescargasComponent } from './informes/descargas/descargas.component';
import { CompañiasComponent } from './administracion/compañias/compañias.component';
import { CompañiaDetailComponent } from './administracion/compañia-detail/compañia-detail.component';
import { FilterPipe } from '../_pipes/filter.pipe';
import { TableDatePipe } from '../_pipes/table-date.pipe';
import { CutStringPipe } from '../_pipes/cut-string.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { HelpComponent } from './help/help.component';
import { PopupEditUserComponent } from './administracion/compañia-detail/edit-user-popup.component';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { PopupDeleteComponent } from './informes/descargas/delete-popup.component';
import { PopupCreateCompanyComponent } from './administracion/compañias/create-company-popup.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastrModule } from 'ngx-toastr';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { LogsComponent } from './informes/logs/logs.component';
import { LogPopupComponent } from './informes/logs/components/log-popup/log-popup.component';
import { CompanyLicenseComponent } from './administracion/compañia-detail/components/licence/license.component';
import { FilesControlComponent } from './utilities/files-control/files-control.component';
import { FilesControlDetailComponent } from './utilities/files-control/details/files-control-detail.component';
import { ResumeComponent } from './utilities/files-control/components/resume/resume.component';
import { HistoryComponent } from './utilities/files-control/components/history/history.component';
import { ActionsComponent } from './utilities/files-control/components/actions/actions.component';
import { PopupCreateUserComponent } from './administracion/compañia-detail/create-user-popup.component';
import { InformesIAComponent } from './informes/ia/informes-ia.component';
import { PopupSensitiveInformationType } from './informes/dlp/popup-sensitive-infomation-types/popup-sensitive-infomation-types.component';
import { PopupLimiteRegistrosComponent } from './informes/components/popup-limite-registros/popup-limite-registros.component';
import { PopupFiltrosDescargaComponent } from './informes/descargas/popup-filtros-descarga.component';
@NgModule({
  declarations: [
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    SidebarMenuComponent,
    IndexComponent,
    PendingEmailVerificationComponent,
    SettingComponent,
    PageVisitedHistoryComponent,
    LoginHistoryComponent,
    ProfileComponent,
    MenuComponent,
    RoleComponent,
    NgbdSortableHeader,
    InformesIRMComponent,
    InformesDLPComponent,
    InformesIAComponent,
    ClasificacionDeDatosComponent,
    EtiquetasDeClasificacionComponent,
    EtiquetasDeConfidencialidadComponent,
    PanelDeCumplimientoComponent,
    ProcedimientosComponent,
    ManualDeUsuarioComponent,
    DescargasComponent,
    CompañiasComponent,
    CompañiaDetailComponent,
    FilterPipe,
    TableDatePipe,
    CutStringPipe,
    HelpComponent,
    PopupEditUserComponent,
    PopupCreateUserComponent,
    PopupDeleteComponent,
    PopupCreateCompanyComponent,
    PopupSensitiveInformationType,
    LogsComponent,
    LogPopupComponent,
    CompanyLicenseComponent,
    FilesControlComponent,
    FilesControlDetailComponent,
    ResumeComponent,
    HistoryComponent,
    ActionsComponent,
    PopupLimiteRegistrosComponent,
    PopupFiltrosDescargaComponent,
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    NgbModule,
    TranslateModule,
    ModalModule.forRoot(),
    NgSelectModule,
    ToastrModule.forRoot(),
    BsDatepickerModule.forRoot(),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    BsModalRef,
  ],
  exports: [ToastrModule],
})
export class HomeModule {}
